export const SURE_TYPES_GET_REQUESTING = 'SURE_TYPES_GET_REQUESTING';
export const SURE_TYPES_GET_SUCCESS = 'SURE_TYPES_GET_SUCCESS';
export const SURE_TYPES_GET_ERROR = 'SURE_TYPES_GET_ERROR';